export enum PaymentMethod {
  PAPERLESS = 'PAPERLESS',
  CUSTOMERS_CHOICE = 'CUSTOMERS_CHOICE',
  ONLINE_PAYMENT = 'ONLINE_PAYMENT',
  CREDIT_CARD = 'CREDIT_CARD',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  CREDIT_TRANSFER = 'CREDIT_TRANSFER',
  MANUAL_PAYMENT = 'MANUAL_PAYMENT',
}
